import { render, staticRenderFns } from "./ObjectDetailsActions.vue?vue&type=template&id=61a73b46&"
import script from "./ObjectDetailsActions.vue?vue&type=script&lang=js&"
export * from "./ObjectDetailsActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports